import { render, staticRenderFns } from "./QueryHeader.vue?vue&type=template&id=a2e5699e&scoped=true&"
import script from "./QueryHeader.vue?vue&type=script&lang=ts&"
export * from "./QueryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./QueryHeader.vue?vue&type=style&index=0&id=a2e5699e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e5699e",
  null
  
)

export default component.exports